/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import { InputAdornment, Typography } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import InputMask from 'react-input-mask'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

import BaseFilter from '../../../components/hooks/BaseFilter'
import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import Icon from '@mdi/react'
import {
  mdiFilterMultiple,
  mdiMagnifyExpand,
  mdiNoteEditOutline,
  mdiSwapVertical,
} from '@mdi/js'
import { DatePicker, KeyboardDatePicker } from '@material-ui/pickers'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import formComponentStyles from '../../../assets/formComponentsStyles'
import colors from '../../../assets/colors'

export default function Filter(props) {
  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const { classes } = props
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const filterClasses = filterStylesComponents()
  const formClasses = formComponentStyles()

  const [form, setForm] = useState({
    phone: '',
    birthdate: null,
    neighborhood: '',
  })

  const [open, setOpen] = useState(false)

  const toggleModal = useCallback(() => {
    setOpen(!open)
  }, [open])

  const onSubmit = (data = form) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handlePhoneChange = e => {
    setForm(prevForm => ({
      ...prevForm,
      phone: e.target.value.replace(/[^\d]/g, ''),
    }))
  }

  const handleDateChange = date => {
    setForm(prevForm => ({
      ...prevForm,
      birthdate: date,
    }))
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)

    data.append('phone', form?.phone.replace(/[^\d]/g, '') || '')
    data.append(
      'birthdate',
      form?.birthdate ? new Date(form.birthdate).toISOString() : ''
    )

    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <BaseFilter>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={8} md={6}>
              <form style={{ width: '100%' }} onSubmit={handleSubmit}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item sm={6} md={8} xs={12}>
                    <TextField
                      fullWidth
                      name="name"
                      defaultValue={filters?.name || ''}
                      label="Filtrar por nome"
                      className={classes.inputFilter}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              type="submit"
                              aria-label="search client"
                            >
                              <Icon path={mdiMagnifyExpand} size={1} />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </form>
            </Grid>

            <Grid item xs>
              <Grid
                container
                spacing={2}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <Button
                    onClick={toggleModal}
                    style={{ color: colors.textPrimary }}
                    className={filterClasses.btnMoreFilters}
                  >
                    <Icon
                      path={mdiFilterMultiple}
                      className={classes.btnIcon}
                      size={1}
                      color={colors.secondary}
                    />
                    Outros filtros
                  </Button>
                </Grid>

                {canCreate('clientes', permissionUser) && (
                  <Grid item>
                    <IconButton
                      component={Link}
                      to="/clients/import"
                      className={filterClasses.btnAdd}
                    >
                      <Icon
                        path={mdiSwapVertical}
                        size={1}
                        style={{ marginRight: '4px' }}
                      />
                      Importar Clientes
                    </IconButton>
                  </Grid>
                )}

                <Grid item>
                  {canCreate('clientes', permissionUser) && (
                    <IconButton
                      component={Link}
                      to="/clients/new"
                      className={filterClasses.btnAdd}
                    >
                      <Icon
                        path={mdiNoteEditOutline}
                        size={1}
                        style={{ marginRight: '4px' }}
                      />
                      Cadastrar
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <BaseFilterModal
        open={open}
        handleOpen={toggleModal}
        title="Filtro"
        hiddenHelpButton
      >
        <Grid item xs={12} style={{ width: '370px' }}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography
                style={{ fontSize: '16px', fontWeight: 'normal' }}
                color={colors.primary}
              >
                Utilize os campos abaixo para encontrar <br /> um cliente
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12}>
                  <TextField
                    name="name"
                    label="Nome"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.name || ''}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <InputMask
                    mask={
                      form.phone?.replace(/[^\d]/g, '').length <= 10
                        ? '(99) 9999-9999?'
                        : '(99) 99999-9999'
                    }
                    formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
                    maskChar=""
                    value={form.phone}
                    onChange={handlePhoneChange}
                  >
                    {inputProps => (
                      <TextField
                        {...inputProps}
                        label="Telefone"
                        margin="dense"
                        fullWidth
                        variant="standard"
                      />
                    )}
                  </InputMask>
                </Grid>

                <Grid item sm={6} xs={12}>
                  <TextField
                    name="email"
                    label="Email"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.email || ''}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <TextField
                    name="neighborhood"
                    label="Bairro"
                    margin="dense"
                    variant="standard"
                    fullWidth
                    defaultValue={filters?.neighborhood || ''}
                  />
                </Grid>

                <Grid item sm={6} xs={12}>
                  <DatePicker
                    clearable
                    value={form.birthdate}
                    label="Aniversário"
                    fullWidth
                    views={['date', 'month']}
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    inputVariant="standard"
                    onChange={handleDateChange}
                    format="d MMMM"
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Button
                    type="submit"
                    color={colors.primary}
                    variant="contained"
                    className={formClasses.btnSubmmit}
                  >
                    <SearchIcon />
                    {` Pesquisar`}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </BaseFilterModal>
    </BaseFilter>
  )
}
